// Mock Data for Integrations Catalog

export const INTEGRATIONS_CATALOG = {
  messengers: [
    {
      id: 'whatsapp-business',
      name: 'WhatsApp Business',
      category: 'Messengers',
      logoType: 'whatsapp',
      installed: false,
      description:
        'Official WhatsApp Business App integration for messaging customers.',
    },
    {
      id: 'instagram',
      name: 'Instagram',
      category: 'Messengers',
      logoType: 'instagram',
      installed: false,
      description:
        'Sync Instagram direct messages, comments and mentions with CRM.',
    },
    {
      id: 'facebook',
      name: 'Facebook',
      category: 'Messengers',
      logoType: 'facebook',
      installed: false,
      description: 'Integrate Facebook Pages, Messenger, and Leads tracking.',
    },
    {
      id: 'threads',
      name: 'Threads',
      category: 'Messengers',
      logoType: 'threads',
      installed: false,
      description:
        'Sync Threads conversations, posts, and replies directly to CRM.',
    },
  ],
  providers: [
    {
      id: 'google_workspace',
      name: 'Google Workspace',
      category: 'Productivity',
      logoType: 'google_workspace',
      installed: false,
      description:
        'Export leads to Sheets, sync Calendar, and attach Drive & Docs.',
    },
    {
      id: 'other_email',
      name: 'Business Email (IMAP/SMTP)',
      category: 'Productivity',
      logoType: 'other_email',
      installed: false,
      description:
        'Connect Gmail, Hostinger, Zoho, cPanel, or any compatible email provider via IMAP and SMTP.',
    },
  ],
};
